/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        datePicker: {
            boxShadow: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "4px",
                            blur: "24px",
                            spread: "-8px",
                            color: "#00000010",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "1px",
                            blur: "6px",
                            spread: "-2px",
                            color: "#00000038",
                        },
                    ],
                    stringValue: "0px 4px 24px -8px #00000010, 0px 1px 6px -2px #00000038",
                },
                type: "shadow",
            },
            borderRadius: {
                value: "4px",
                type: "dimension",
            },
            backgroundColor: {
                value: "#ffffff",
                type: "color",
            },
            header: {
                backgroundColor: {
                    value: "#2F3B4D",
                    type: "color",
                },
                color: {
                    value: "#ffffff",
                    type: "color",
                },
                paddingHorizontal: {
                    value: "24px",
                    type: "dimension",
                },
                paddingTop: {
                    value: "24px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "16px",
                    type: "dimension",
                },
                gap: {
                    value: "4px",
                    type: "dimension",
                },
                title: {
                    fontSize: {
                        value: "1rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "fontWeight",
                    },
                    lineHeight: {
                        value: "1.25rem",
                        type: "dimension",
                    },
                },
                subtitle: {
                    fontSize: {
                        value: "1.75rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 600,
                        type: "fontWeight",
                    },
                    lineHeight: {
                        value: "2rem",
                        type: "dimension",
                    },
                },
                controls: {
                    label: {
                        color: {
                            value: "#1e1e1e",
                            type: "color",
                        },
                        fontSize: {
                            value: "1rem",
                            type: "dimension",
                        },
                        fontWeight: {
                            value: 400,
                            type: "fontWeight",
                        },
                        lineHeight: {
                            value: "1.25rem",
                            type: "dimension",
                        },
                    },
                    disabled: {
                        color: {
                            value: "#455D82",
                            type: "color",
                        },
                    },
                },
            },
            calendar: {
                padding: {
                    value: "24px",
                    type: "dimension",
                },
                gap: {
                    value: "8px",
                    type: "dimension",
                },
            },
            footer: {
                paddingHorizontal: {
                    value: "16px",
                    type: "dimension",
                },
                paddingVertical: {
                    value: "20px",
                    type: "dimension",
                },
            },
            day: {
                borderRadius: {
                    value: "4px",
                    type: "dimension",
                },
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
                width: {
                    value: "32px",
                    type: "dimension",
                },
                height: {
                    value: "32px",
                    type: "dimension",
                },
                today: {
                    borderColor: {
                        value: "#2F3B4D",
                        type: "color",
                    },
                    borderWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                },
                selected: {
                    backgroundColor: {
                        value: "#2F3B4D",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                range: {
                    backgroundColor: {
                        value: "#D5E3F1",
                        type: "color",
                    },
                },
            },
            week: {
                color: {
                    value: "#b3b3b3",
                    type: "color",
                },
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
            },
        },
    },
};
export default tokens;
